import { render, staticRenderFns } from "./QRReaderView.vue?vue&type=template&id=0b665922&scoped=true"
import script from "./QRReaderView.vue?vue&type=script&lang=js"
export * from "./QRReaderView.vue?vue&type=script&lang=js"
import style1 from "./QRReaderView.vue?vue&type=style&index=1&id=0b665922&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b665922",
  null
  
)

export default component.exports